module.exports = __webpack_public_path__ + "img/telegram_hover.5eb7e896.png";